// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { plugin as Alcapone } from '@mc-alberta/alcapone'
import * as i18nData from '@mc-alberta/i18n-data'
import { lumber } from '@mc-alberta/lumber'
import nudetect from '@mc-alberta/nudetect'
import {
  addNudetectWidgetHeader,
  logXhrFinish,
  logXhrInit,
  logXhrReject,
  logXhrStart
} from '@mc-alberta/supernova-scripts'
import * as switchboard from '@mc-alberta/switchboard'
import { setAutocompleteApiKey } from '@mc-alberta/tuxedo'
import VeeValidate from '@mc-alberta/vee-validate-legacy'
import VueCompositionApi from '@vue/composition-api'
import axios from 'axios'
import Vue from 'vue'
import akamai from '@/api/akamai'
import CONSTANTS, { REMOTE_LOG } from '@/constants'
import { getI18nSingleton } from '@/i18n'
import { analytics } from '@/plugins'
import router from '@/router'
import store from '@/store'
import { setCorrelationId } from '@/utils/correlationId'
import { getTraceId } from '@/utils/traceId'
import { registerValidations } from '@/validations'
import App from './App'
import { experiments } from './experiments'

logXhrInit({ apiEndpoint: REMOTE_LOG.API_ENDPOINT })
axios.interceptors.response.use(
  (_) => _,
  (config) => store.dispatch('intercept', config)
)
axios.interceptors.request.use(logXhrStart, logXhrReject)
axios.interceptors.response.use(logXhrFinish, logXhrReject)
axios.interceptors.request.use(addNudetectWidgetHeader)
axios.interceptors.response.use(setCorrelationId)

const i18n = getI18nSingleton()
const urlParams = new URLSearchParams(window.location.search)

// get traceId from URL only when coming from DCF
const traceId =
  urlParams.get('initiator') === CONSTANTS.DCF ? getTraceId(urlParams.get('traceId')) : getTraceId()

nudetect.initialize(traceId, process.env.NUDETECT_BASE_URL)

lumber.bootstrap({ name: 'AMS', version: process.env.APP_VERSION, traceId })
lumber.setLogConstants({ browser: navigator?.userAgent })

Vue.config.productionTip = false

// get the akamai tag the first chance we get before we make any other api calls
// while this call is async, there's no reason for us to await for a response. ~ Ronald
akamai.getTag()

// PLUGINS //
Vue.use(VueCompositionApi)
Vue.use(i18nData.pluginVue2, {
  /**
   * Enabling beta countries will return all the countries available in the config in i18n-data.
   *
   * This is so that the countries in beta can be available locally and in lower environments
   */
  betaCountries: switchboard.isBetaMarketsEnabled()
})
Vue.use(Alcapone, { enableThemes: true })
Vue.use(analytics, { analyticsUrl: process.env.ADOBE_LAUNCH_URL })

Vue.use(VeeValidate, { delay: 100, i18n }) // need delay, otherwise validates too quickly
registerValidations()

Vue.use(switchboard.plugin, {
  experiments,
  country: i18nData.getCountryFeatures(),
  traceId,
  // features enabled in production with beta cookie
  release: []
})

setAutocompleteApiKey(process.env.GOOGLE_PLACES_API_KEY)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})
